import React, { ComponentType, useCallback } from 'react';
import { FastField, getIn } from 'formik';

const Field: ComponentType<any> = ({ shouldUpdate, ...props }) => {
  const shouldUpdateCallback = useCallback(
    (nextProps: any, currentProps: any) => {
      const defaultCheck =
        getIn(nextProps.formik.values, props.name) !==
          getIn(currentProps.formik.values, props.name) ||
        nextProps.name !== currentProps.name ||
        nextProps.suffix !== currentProps.suffix ||
        nextProps.formik.values[nextProps.name] !== currentProps.formik.values[currentProps.name] ||
        nextProps.formik.errors[nextProps.name] !== currentProps.formik.errors[currentProps.name] ||
        nextProps.formik.touched[nextProps.name] !==
          currentProps.formik.touched[currentProps.name] ||
        nextProps.formik.isSubmitting !== currentProps.formik.isSubmitting ||
        nextProps.formik.editable !== currentProps.formik.editable ||
        Object.keys(currentProps).length !== Object.keys(nextProps).length;

      return (
        defaultCheck ||
        nextProps.editable !== currentProps.editable ||
        !!(shouldUpdate && shouldUpdate(nextProps, currentProps))
      );
    },
    [shouldUpdate, props.name],
  );

  return <FastField shouldUpdate={shouldUpdateCallback} {...props} />;
};

export default Field;
